export function enumEncode(value: string, def: EnumDef): string {
  for (const key of Object.keys(def.c)) {
    if (def.c[key].l.ja === value) {
      return key
    }
  }
  return null
}

export function enumDecode(value: string, def: EnumDef): LangString {
  return def && def.c[value] && def.c[value].l
}

export function enumDecoder(def: EnumDef): (v: string) => LangString {
  return value => enumDecode(value, def)
}

export function enumToSelectOption(
  def: EnumDef,
  except: string[] = [],
  only: string[] = [],
  isEn = false,
) {
  if (!def || !except || !only) {
    return []
  }
  return Object.keys(def.c)
    .filter(
      key => !except.includes(key) && (only.length === 0 || only.includes(key)),
    )
    .map(key => {
      return { value: key, name: isEn ? def.c[key].l.en : def.c[key].l.ja }
    })
}

export function getVersion(data: any): EsData {
  return {
    version: data.version,
    seqNo: data.seqNo,
    primaryTerm: data.primaryTerm,
  }
}

export function removeVersion(data: any): void {
  delete data.version
  delete data.seqNo
  delete data.primaryTerm
}

export function setVersion(data: any, version: EsData): void {
  data.version = version.version
  data.seqNo = version.seqNo
  data.primaryTerm = version.primaryTerm
}

export function enumRecode(label: string, def: EnumDef): string {
  return Object.keys(def.c)
    .filter(key => def.c[key].l.ja === label)
    .pop()
}

const map = {
  SYSTEM: 5,
  ADMIN: 4,
  MANAGE: 3,
  EDIT: 2,
  READ: 1,
  NONE: 0,
}

export function hasPermissionLevel(
  targetLv: PermissionLevel,
  lv: PermissionLevel,
) {
  return map[targetLv] >= map[lv]
}
